import { AppointmentDataDto, IntervenorDataDto, TypeOfFinalTransaction } from "../../dtos/KioskDtos.dtos";
import React = require("react");
import { IAppointmentConfirmationProps } from "./Types";
import TimeDateUtilities from "../../constants/TimeAndDate";
import { IGenericsLang } from "../../services/Language/Types";
import { LanguageCodes } from "../../constants/languages";
import { Loader } from "../genericComponents/Loader/Loader";
const intervenantImg = require("../../assets/images/intervenants.png");
const warningImg = require("../../assets/images/warning-icon.png");
import "./AppointmentConfirmation.css";
import "./MultiSiteConfirmationPopup.css"

export const renderAppointmentsList = (
    appointments: AppointmentDataDto[],
    isAppointmentLate: boolean = false,
    props: IAppointmentConfirmationProps
) => {
    return (
        <table className="appointment-list-table" style={{ width: "100%", borderSpacing: "5px 20px" }}>
            <tbody>
                {appointments.map((appt, index) => {
                    return renderAppointmentInfo(index, props, appt, isAppointmentLate);
                })}
            </tbody>
        </table>
    );
};

const renderPhysicianList = (physicians: IntervenorDataDto[], textString: IGenericsLang, lang: LanguageCodes) => {
    const renderFn = (person: IntervenorDataDto, extraText: string = "") => (
        <h2 style={{ fontSize: "34px" }}>
            {person.titles[lang] + " " + person.firstName + " " + person.lastName + " " + extraText}
        </h2>
    );
    return getPhysicianLines(physicians, textString, renderFn);
};

const renderConfirmedPhysicianList = (physicians: IntervenorDataDto[], textString: IGenericsLang, lang: LanguageCodes) => {
    const renderFn = (person: IntervenorDataDto, extraText: string = "") => (
        <div style={{ fontSize: "20px", marginBottom:"-10px" }}>
            {person.titles[lang] + " " + person.firstName + " " + person.lastName + " " + extraText}
        </div>
    );
    return getPhysicianLines(physicians, textString, renderFn);
};

const getPhysicianLines = (
  physicians: IntervenorDataDto[],
  textString: IGenericsLang,
  renderFn: (person: IntervenorDataDto, extraText?: string) => React.ReactNode
): React.ReactNode => {
  if (!physicians || physicians.length === 0) 
    return null;

  switch (physicians.length) {
    case 1:
      return renderFn(physicians[0]);
    case 2:
      return (
        <>
          {renderFn(physicians[0], textString.labels.AndLabel)}
          {renderFn(physicians[1])}
        </>
      );
    default:
      return (
        <>
          {renderFn(physicians[0], ",")}
          {renderFn(physicians[1], "...")}
        </>
      );
  }
};

export const renderAppointmentInfo = (
    index: number,
    props: IAppointmentConfirmationProps,
    appt: AppointmentDataDto,
    isAppointmentLate: boolean
): JSX.Element => {
    return (
        <tr className="row" key={"appointment-list-existing-" + index} style={{ marginTop: "10px" }}>
            <td style={{ width: "40%" }}>
                {props.showProfilePicture && appt.intervenors.length === 1 ? (
                    <ImageBlock profilePictureUrl={appt.intervenors[0].profilePictureUrl} />
                ) : (
                        <img
                            src={intervenantImg}
                            className="appointment-confirmation-image-block"
                        />
                    )}
            </td>
            <td style={{ float: "left", verticalAlign: "middle" }}>
                <div style={{ display: "inline-block" }}>
                    {renderPhysicianList(appt.intervenors, props.textString, props.lang)}
                    <p style={{ fontSize: "24px" }} className={isAppointmentLate ? "validation-block" : ""}>
                        {props.textString.labels.AppointmentAtLabel + " "}
                        {TimeDateUtilities.getTimeStringByLanguage(appt.scheduledDateTime, props.lang)}
                    </p>
                </div>
            </td>
        </tr>
    );
};

export const renderConfirmedAppointmentInfo = (
    index: number,
    props: IAppointmentConfirmationProps,
    appt: AppointmentDataDto
): JSX.Element => {

    const localizedKioskInstruction = props.sites.find(site => site.id === appt.siteId) .localizedKioskInstruction[props.lang];

    return (
        <div key={`appointment-list-existing-${index}`} className="appointment-card">

            <div className="appointment-card__physician">
                <span style={{fontWeight:"normal"}}>{props.textString.labels.AppointmentWithLabel + " "}</span>
                {renderConfirmedPhysicianList(appt.intervenors, props.textString, props.lang)}
            </div>

            <div className="appointment-card__time" >
                {props.textString.labels.AtLabel + " "}
                {TimeDateUtilities.getTimeStringByLanguage(appt.scheduledDateTime, props.lang)}
            </div>
            
            <div className="appointment-card__instruction">
                <img src={warningImg} alt="warning" />
                <div className="appointment-card__instruction-text">
                    {!localizedKioskInstruction ? props.textString.messagesInstructions.ProcedeToWaitingRoomInstruction : localizedKioskInstruction}
                </div>
            </div>
        </div>
    );
};


const ImageBlock = (props: { profilePictureUrl: string }) => {
    const [url, setUrl] = React.useState(props.profilePictureUrl);
    const onErrorSet = () => setUrl(null);
    return (
        <img
            src={url || intervenantImg}
            onError={onErrorSet}
            className="appointment-confirmation-image-block"
        />
    );
};

export const renderConfirmationButtons = (
    showConfirmButton: boolean,
    props: IAppointmentConfirmationProps,
    isLoading: boolean,
    potentialFinalTransaction?: TypeOfFinalTransaction
) => (
        <div>
            {isLoading ? (
                <div className="loader-parent text-center">
                    <Loader />
                </div>
            ) : (
                    <div className="col-md-12 text-center" style={{ paddingTop: "35px" }}>
                        <button className="buttons-white" onClick={() => showConfirmButton ? props.cancel() : props.return(potentialFinalTransaction)}>
                            {props.textString.labels.ExitButton}
                        </button>
                        {showConfirmButton && (
                            <button
                                disabled={props.isLoadingSpinnerActive}
                                className="buttons-blue"
                                onClick={() => {
                                    props.confirmSelectedAppointment(
                                        props.appointments.validAppointments.map(
                                            (appt: AppointmentDataDto) => appt.appointmentId
                                        )
                                    );
                                }}
                            >
                                {props.textString.labels.ConfirmButton}
                            </button>
                        )}
                    </div>
                )}
        </div>
    );

export const cantCheckinBecauseOfFutureAppointmentsMessage = (
    text: IGenericsLang,
    isThereMultipleAppointments: boolean,
    returnTime: string
) => (
        <div className="text-center" style={{ padding: "0 25px" }}>
            <p className="validation-block" style={{ fontSize: "35px" }}>
                {isThereMultipleAppointments
                    ? text.messagesInstructions.CantCheckinForLaterAppointmentsMessage
                    : text.messagesInstructions.CantCheckinForLaterAppointmentMessage}
            </p>
            <div style={{ height: "30px" }} />
            <h3 style={{ fontSize: "45px" }}>
                {text.messagesInstructions.ComeBackAtTimeToCheckinInstruction.replace("{time}", returnTime)}
            </h3>
        </div>
    );



// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/SubComponents.tsx